function objectWithoutProperties(obj, exclude) {
  var target = {}
  for (var k in obj)
    if (
      Object.prototype.hasOwnProperty.call(obj, k) &&
      exclude.indexOf(k) === -1
    )
      target[k] = obj[k]
  return target
}
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid px-0" },
    _vm._l(_vm.activeSelectors, function(ref) {
      var index = ref.index
      var rest = objectWithoutProperties(ref, ["index"])
      var selector = rest
      return _c("div", { key: index, staticClass: "row row-gap-1 mt-4" }, [
        _c("h6", { staticClass: "col-11 -mr-4" }, [
          _vm._v(" " + _vm._s(selector.label) + " "),
          _vm.getMinFiles(index)
            ? _c("span", { staticClass: "text-danger" }, [
                _c("b", [_vm._v("*")])
              ])
            : _vm._e()
        ]),
        _c(
          "h6",
          {
            staticClass:
              "col-1 bg-grey shadow-inner rounded-lg p-1 text-center text-white"
          },
          [
            _c(
              "vx-tooltip",
              {
                attrs: {
                  classx: "text-center",
                  text: _vm.getFileCountTooltip(index),
                  position: "top"
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.getFileCount(index) + "/" + _vm.getMaxFiles(index)
                    ) +
                    " "
                )
              ]
            )
          ],
          1
        ),
        _vm.canUploadFromRepo(selector.uploadFrom)
          ? _c(
              "div",
              {
                staticClass: "col-6",
                class: { "col-12": !_vm.canUploadFromPC(selector.uploadFrom) }
              },
              [
                _c(
                  "vx-tooltip",
                  {
                    attrs: {
                      text: _vm.getTooltip(index, "repo"),
                      position: "top"
                    }
                  },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "has-permission",
                            rawName: "v-has-permission",
                            value: "ED060",
                            expression: "'ED060'"
                          },
                          {
                            name: "b-modal",
                            rawName: "v-b-modal",
                            value: "repository-modal-" + index,
                            expression: "`repository-modal-${index}`"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          variant: "primary",
                          disabled: _vm.isDisabled(index)
                        }
                      },
                      [
                        _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                        _vm._v(
                          " Seleccionar archivo" +
                            _vm._s(_vm.getMaxFiles(index) > 1 ? "s" : "") +
                            " "
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.canUploadFromPC(selector.uploadFrom)
          ? _c(
              "div",
              {
                staticClass: "col-6",
                class: { "col-12": !_vm.canUploadFromRepo(selector.uploadFrom) }
              },
              [
                _c(
                  "vx-tooltip",
                  {
                    attrs: {
                      text: _vm.getTooltip(index, "pc"),
                      position: "top"
                    }
                  },
                  [
                    _c("upload-file", {
                      attrs: {
                        disabled: _vm.isDisabled(index),
                        color: "primary",
                        permission: "*",
                        accept: selector.accept || _vm.defaultFileTypes,
                        "data-cy": "uploadFile",
                        "button-class": "btn-block",
                        "container-class": "w-100",
                        "upload-to": "ed",
                        "with-sha": ""
                      },
                      on: {
                        input: function($event) {
                          return _vm.addFile(
                            _vm.experienceFile,
                            index,
                            selector
                          )
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("feather-icon", {
                                  attrs: { icon: "UploadIcon" }
                                }),
                                _vm._v(" Subir archivo ")
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.experienceFile,
                        callback: function($$v) {
                          _vm.experienceFile = $$v
                        },
                        expression: "experienceFile"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.canUploadFromRepo(selector.uploadFrom)
          ? _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("repository-selector", {
                  key: index,
                  attrs: {
                    "modal-id": "repository-modal-" + index,
                    "max-files": selector.maxFiles || 1,
                    "required-file-type": selector.type,
                    "accepted-file-extensions": selector.accept,
                    "add-file": function(file) {
                      return _vm.addFile(file, index, selector)
                    },
                    files: _vm.internalFiles[index] || [],
                    "remove-file": function(file) {
                      return _vm.removeFile(file, index)
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-12 mt-2" },
          [
            _c("file-list", {
              attrs: { files: _vm.internalFiles[index] || [] },
              on: {
                "remove-file": function(fileId) {
                  return _vm.removeFile(fileId, index)
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _vm.getErrors(index).length
              ? _c("v-invalid-feedback", [
                  _vm._v(" " + _vm._s(_vm.getErrors(index)) + " ")
                ])
              : _vm._e()
          ],
          1
        ),
        index < _vm.activeSelectors.length - 1
          ? _c(
              "div",
              { staticClass: "col-12" },
              [_c("vs-divider", { staticClass: "my-2" })],
              1
            )
          : _vm._e()
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }